import * as React from "react";

const SVGComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1024 1024"
        {...props}
    >
        <defs>
            <style>
                {
                    ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f62584;}.cls-3{fill:#4361ed;}.cls-4{fill:#3a0ca2;}.cls-5{fill:#7209b6;}.cls-6{fill:#4cc8ef;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{mix-blend-mode:soft-light;}.cls-13{isolation:isolate;}\n        "
                }
            </style>
            <linearGradient
                id="linear-gradient"
                x1={300.1}
                y1={741.67}
                x2={228.74}
                y2={184.59}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.04} stopColor="#fff" />
                <stop offset={0.09} stopColor="#fff" stopOpacity={0.79} />
                <stop offset={0.14} stopColor="#fff" stopOpacity={0.58} />
                <stop offset={0.2} stopColor="#fff" stopOpacity={0.4} />
                <stop offset={0.26} stopColor="#fff" stopOpacity={0.26} />
                <stop offset={0.31} stopColor="#fff" stopOpacity={0.14} />
                <stop offset={0.37} stopColor="#fff" stopOpacity={0.06} />
                <stop offset={0.43} stopColor="#fff" stopOpacity={0.02} />
                <stop offset={0.48} stopColor="#fff" stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="linear-gradient-2"
                x1={6471.66}
                y1={-2368.07}
                x2={6400.3}
                y2={-2925.17}
                gradientTransform="translate(-580.13 7598.94) rotate(-60)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-3"
                x1={12240.39}
                y1={1434.69}
                x2={12169.02}
                y2={877.6}
                gradientTransform="translate(5694.54 11898.44) rotate(-120)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-4"
                x1={11839.13}
                y1={8339.12}
                x2={11767.76}
                y2={7782.04}
                gradientTransform="translate(12563.02 8621.43) rotate(-180)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-5"
                x1={5645.48}
                y1={11435.88}
                x2={5574.11}
                y2={10878.78}
                gradientTransform="translate(13145.62 1042.54) rotate(120)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-6"
                x1={-143.41}
                y1={7633.33}
                x2={-214.77}
                y2={7076.24}
                gradientTransform="translate(6889.53 -3249.07) rotate(60)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.04} stopColor="#000" />
                <stop offset={0.48} stopColor="#000" stopOpacity={0} />
            </linearGradient>
        </defs>
        <g className="cls-13">
            <g id="Layer_1">
                <g>
                    <path
                        className="cls-4"
                        d="M921.35,819.52v.03c-93.41,124.14-242,204.43-409.35,204.43-20.9,0-41.49-1.26-61.72-3.69,163.98-107.71,238.18-304.79,195.1-488.66-10.06-42.92-26.51-85.14-49.69-125.32,180.75,54.64,314.34,217.4,325.66,413.22Z"
                    />
                    <path
                        className="cls-3"
                        d="M378.62,492.38c10.06,42.92,26.51,85.14,49.69,125.32C247.55,563.06,113.95,400.29,102.65,204.45,196.06,80.31,344.65,.02,512,.02c20.9,0,41.48,1.26,61.72,3.69-163.98,107.69-238.18,304.78-195.1,488.66Z"
                    />
                    <path
                        className="cls-2"
                        d="M983.19,311.36c-175.29-88.22-383.13-53.95-520.86,75.32-32.16,30.17-60.49,65.52-83.71,105.7-43.08-183.88,31.12-380.97,195.1-488.66,184.69,22.18,339.13,142.68,409.47,307.64Z"
                    />
                    <path
                        className="cls-5"
                        d="M1024,512c0,115.44-38.19,221.9-102.65,307.52-11.31-195.83-144.91-358.59-325.66-413.22-42.21-12.75-86.97-19.61-133.36-19.62,137.73-129.26,345.57-163.54,520.86-75.32,26.28,61.61,40.81,129.43,40.81,200.64Z"
                    />
                    <path
                        className="cls-2"
                        d="M450.28,1020.28c-184.69-22.18-339.12-142.68-409.47-307.63,175.29,88.19,383.11,53.93,520.85-75.33h.02c32.16-30.17,60.49-65.52,83.71-105.7,43.08,183.87-31.12,380.95-195.1,488.66Z"
                    />
                    <path
                        className="cls-6"
                        d="M561.66,637.32c-137.73,129.26-345.55,163.53-520.85,75.33C14.53,651.04,0,583.22,0,512c0-115.44,38.19-221.93,102.65-307.55,11.3,195.84,144.89,358.62,325.66,413.25,42.21,12.75,86.96,19.61,133.35,19.62Z"
                    />
                    <g className="cls-12">
                        <path
                            className="cls-1"
                            d="M561.66,637.32c-137.73,129.26-345.55,163.53-520.85,75.33C14.53,651.04,0,583.22,0,512c0-115.44,38.19-221.93,102.65-307.55,11.3,195.84,144.89,358.62,325.66,413.25,42.21,12.75,86.96,19.61,133.35,19.62Z"
                        />
                        <path
                            className="cls-9"
                            d="M645.29,531.6c43.08,183.9-31.15,381.01-195.18,488.71-66.5-8.05-132.5-29.37-194.19-64.99-99.97-57.72-173.11-144.04-215.03-242.67,175.26,88.14,383.03,53.83,520.73-75.39,32.15-30.17,60.46-65.5,83.67-105.67Z"
                        />
                        <path
                            className="cls-7"
                            d="M595.68,406.28c180.82,54.64,314.4,217.48,325.66,413.38-40.22,53.56-91.69,100.06-153.37,135.67-99.97,57.72-211.3,77.9-317.69,64.88,163.96-107.71,238.14-304.78,195.08-488.64-10.06-42.93-26.5-85.11-49.68-125.29Z"
                        />
                        <path
                            className="cls-8"
                            d="M462.34,386.66c137.73-129.26,345.55-163.53,520.85-75.33,26.28,61.61,40.81,129.43,40.81,200.66,0,115.44-38.19,221.93-102.65,307.55-11.3-195.84-144.89-358.62-325.65-413.25-42.21-12.75-86.96-19.61-133.35-19.62Z"
                        />
                        <path
                            className="cls-11"
                            d="M378.71,492.4c-43.08-183.9,31.15-381.01,195.18-488.71,66.5,8.05,132.5,29.37,194.19,64.99,99.97,57.72,173.11,144.04,215.03,242.67-175.26-88.14-383.03-53.83-520.73,75.39-32.15,30.17-60.46,65.5-83.67,105.67Z"
                        />
                        <path
                            className="cls-10"
                            d="M428.32,617.72C247.51,563.08,113.92,400.24,102.66,204.34c40.22-53.56,91.69-100.06,153.37-135.67C356.01,10.96,467.33-9.22,573.72,3.8c-163.96,107.71-238.14,304.78-195.08,488.64,10.06,42.93,26.5,85.11,49.68,125.29Z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default SVGComponent;
